<sd-border-wrapper [title]="'checkout.address.shipping' | translate" customClass="brand--h4 is-capitalized" [titleLevel]="!!isMobile$ ? 4 : 3">
  @if (shippingMethods?.promo) {
    <sd-html
      innerClass="c__shipping-promo is-caption is-wysiwyg"
      [html]="shippingMethods.promo"
      tag="div"
      data-testid="html-element"
    />
  }
  <div class="c__wrapper">
    <sd-title [titleLevel]="!!isMobile$ ? 4 : 3" customClass="brand--h5 c__shipping-title-choice" data-testid="title-element">
      {{'checkout.address.shippingChoice' | translate}}
    </sd-title>
    <sd-form radio-group
      class="c__btn-group"
      [formControlName]="shippingMethods?.nameField"
      [disabled]="shippingMethods?.disabled"
      [nameField]="shippingMethods?.nameField"
      [labelHidden]="shippingMethods?.labelHidden"
      [labelTitle]="shippingMethods?.labelTitle"
      [items]="shippingMethods?.methods"
      [required]="shippingMethods?.required"
      data-testid="form-element"
    >
      <ng-content />
    </sd-form>
  </div>
</sd-border-wrapper>
